export default __webpack_public_path__ + "static/media/Scholar's Regalia of the Exiled.37933a78.jpg";